import React, { useEffect } from 'react';

const GoogleCallback = () => {
  useEffect(() => {
    const handleGoogleCallback = () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      const userData = params.get("user");
      const name = params.get("name");
      const email = params.get("email");
      const firstLogin = params.get("firstLogin") === "true";

      console.log("🔄 Processing Google OAuth callback");

      if (token) {
        // Store authentication data
        localStorage.setItem("auth_token", token);
        
        // Store user data consistently with regular login
        if (userData) {
          localStorage.setItem("user", userData);
        } else if (name || email) {
          // Create user object from individual parameters
          const user = {
            name: name || "",
            email: email || ""
          };
          localStorage.setItem("user", JSON.stringify(user));
        }
        
        localStorage.setItem("is_first_login", firstLogin ? "true" : "false");
        localStorage.setItem("last_activity_time", Date.now().toString());

        console.log("✅ Google OAuth login successful");

        // Open wallet in new tab
        const walletUrl = `${window.location.origin}/customer/wallet`;
        const newWindow = window.open(walletUrl, '_blank');
        
        if (newWindow) {
          console.log("📍 Opening wallet in new tab");
          // Close the callback tab after a short delay
          setTimeout(() => {
            window.close();
          }, 1000);
        } else {
          console.log("❌ Failed to open new tab, redirecting in current tab");
          window.location.href = walletUrl;
        }
      } else {
        console.error("❌ No token received from Google OAuth");
        // If no token, redirect to login
        window.location.href = '/sign_in';
      }
    };

    handleGoogleCallback();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#001964',
      color: 'white'
    }}>
      <h3>Processing your login...</h3>
      <p>Please wait while we redirect you.</p>
      <p style={{ fontSize: '14px', opacity: 0.8 }}>
        If this page doesn't close automatically, you can close it manually.
      </p>
    </div>
  );
};

export default GoogleCallback;